import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { EaSimulationScpiPackFormComponent } from '@app/forms/simulation/ea-simulation-scpi-pack-form/ea-simulation-scpi-pack-form.component';
import {
  CashOrCredit,
  PackService,
  SimulationPack,
} from '../simulation-pack.service';

export class SCPIPackService implements PackService {
  constructor(private simulationDao: SimulationDao) {}

  type = 'scpi';
  template = {
    panelTitle: 'CHOISISSEZ VOTRE PACK OU LES SCPI DE VOTRE CHOIX',
    tableTitle: 'Liste des SCPI',
    tableButtonText: 'Choisissez vos SCPI',
    tableEmptyText: 'Choisir mes SCPI',
    tableAdjusmentText:
      'La répartition a été ajustée en fonction du prix des parts des SCPI au plus proche de la répartition que vous désiriez',
  };

  customPack: SimulationPack = {
    name: 'Selection Manuelle',
    description:
      'Constituez vous-même votre PACK SCPI en sélectionnant vos favorites parmis notre liste de plus de 150 SCPI.',
    allocation: [],
    buttonText: 'Je choisis moi-même mes SCPI',
  };

  packForm = EaSimulationScpiPackFormComponent;

  getPacks(productId?: number, cashOrCredit?: CashOrCredit) {
    return this.simulationDao.getScpiPacks(cashOrCredit);
  }
}
